import { ReactComponent as Plus } from "./svg/icon-plus.svg";

export const IconPlus = () => <Plus />;
